package com.milta.core.localization.translations.en

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "AI",
    menuAiLegend = "AI: automatic reading by artificial intelligence, which uses your AI credit. For Excel, only if the columns are not recognised.",
    menuExhaustedTitle = "AI credit used up — resets on {date}.",
    menuExhaustedMessage = "Scanning and PDF import are disabled. A spreadsheet with the expected columns and manual entry are still available.",
    modeDisabledReason = "AI credit used up",
    exhaustedBannerWebTitle = "AI credit used up — resets on {date}.",
    exhaustedBannerWebMessage = "PDFs can no longer be analysed. Import an Excel or CSV file with the expected columns, or add the deliveries manually from the mobile app.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) or CSV · 500 stops max · 10 MB",
    pdfUnavailableUntil = "PDF unavailable until {date}",
    pdfRefusedTitle = "AI credit used up — this PDF cannot be analysed",
    pdfRefusedMessage = "“{file}” needs to be read by AI. Your credit returns on {date}. Until then, import an Excel or CSV file with the expected columns, or add the deliveries manually from the mobile app.",
    spreadsheetExhaustedTitle = "Unrecognised columns — AI credit used up",
    spreadsheetExhaustedWebMessage = "The columns in “{file}” do not match the expected columns, and your AI credit no longer allows them to be matched automatically (back on {date}). Rename the columns as shown below, or add the deliveries manually from the mobile app.",
    expectedColumnsNoCreditHint = "A file that follows these columns is imported without AI and uses no credit, even at 0%.",
    importExhaustedTitle = "AI credit used up",
    importExhaustedPhotoMessage = "Your AI credit reached 0% while this import was waiting. The photo was not analysed and nothing was counted. Resets on {date}.",
    importExhaustedFileMessage = "Your AI credit reached 0% while this import was waiting. The file was not analysed and nothing was counted. Resets on {date}.",
    importSpreadsheetExhaustedMessage = "The columns in this file do not match the expected columns, and your AI credit no longer allows them to be matched automatically. Resets on {date}.",
    stepPhotoSent = "Photo sent",
    stepFileSent = "File sent: {file}",
    stepAnalysisNotStarted = "Analysis not started: AI credit used up",
    stepFileRead = "File read: {file}",
    stepExpectedColumns = "Expected columns: Recipient name, Full address",
    stepDeliveriesKept = "Deliveries already entered are kept",
    retryAvailableOn = "Retry — available on {date}",
    manualEntryAction = "Manual entry",
    myUsageTitle = "My usage",
    myUsageAttachedDriverNote = "Only your own actions appear here. What your Enterprises run for you is counted on their side.",
    tabOptimizations = "Optimizations",
    tabAiCredit = "AI credit",
    remainingForPeriod = "AI credit left for this period",
    percentValue = "{percent}%",
    remainingSuffix = "AI credit left",
    lowPill = "Low credit",
    exhaustedPill = "Used up · scanning and PDF import disabled",
    driverNote = "Your credit returns when the subscription renews (your Enterprise's subscription if you belong to one). Unused credit does not carry over.",
    enterpriseNote = "Returns when your subscription renews, with no carry-over. This credit only covers your own AI actions; each driver has their own.",
    exhaustedNote = "Manual entry and spreadsheets with the expected columns are still available. Credit returns when your subscription renews.",
    webScopeHint = "This credit only covers this account's AI actions: scans, PDF or photo imports, unrecognised spreadsheet columns. Each driver has their own.",
    profileValue = "{optimizations} · AI {percent}%",
    profileValueAiOnly = "AI {percent}%",
    columnShare = "Share of credit",
    actionScanDeliveryList = "List scan",
    actionScanPackageLabel = "Label scan",
    actionImportPdf = "PDF import",
    actionImportUnstructured = "Background import",
    actionSpreadsheetMapping = "Spreadsheet columns (AI)",
    outcomeSuccess = "Succeeded",
    outcomeFailed = "Failed",
    outcomeUnreadable = "Unreadable",
    countedSuffix = "(counted)",
    rowDateTime = "{date} at {time}",
    limitsEyebrow = "AI credit per period",
    limitsDescription = "Amount in euros each account can spend on AI calls (scans, PDF or photo imports, unrecognised spreadsheet columns) per subscription period. Credit returns to the limit when the subscription renews, with no carry-over.",
    weightedEquivalent = "≈ {tokens} weighted tokens",
    limitsFootnote = "An Enterprise's driver gets the “Driver” limit, trial while their Enterprise is on trial. The token equivalent is shown for information only and is recalculated with the rate below.",
    conversionEyebrow = "Conversion and alert",
    rateLabel = "Exchange rate",
    rateHint = "Updated manually · applies to subsequent calls",
    thresholdLabel = "Low credit alert",
    thresholdUnit = "% left",
    thresholdHint = "Percentage shown in orange and a banner once per period",
    calculationTitle = "How the cost of a call is calculated.",
    calculationBody = "Claude Haiku 4.5: 1 $ per million input tokens, 5 $ per million output tokens. Weighted token = input × 1 + output × 5, so 1 $ = 1,000,000 weighted tokens. Cost in euros = cost in dollars ÷ rate. Example: an average list scan (5,014 input + 1,792 output) = 13,974 weighted tokens = 0.014 $ ≈ 0.013 €.",
    settingsSavedTitle = "Limits saved.",
    settingsSavedDetail = "Enterprise: {enterpriseTrial} trial · {enterprisePaid} paid. Driver: {driverTrial} trial · {driverPaid} paid. Rate {rate}. Alert {threshold}%.",
    limitTooHigh = "Maximum 1,000 €.",
    rateTooHigh = "Maximum 10.",
    thresholdOutOfRange = "Between 1 and 99.",
    adminCreditTitle = "AI credit",
    adminRemainingLine = "≈ {tokens} weighted tokens left · consumed {consumed}",
    adminOverrunLine = "Consumed {consumed} · overrun of {over}",
    adminLowPill = "Low credit · below {threshold}%",
    adminLowPillNoThreshold = "Low credit",
    adminExhaustedPill = "Credit used up · AI actions disabled",
    adminAppliedAfterReplacement = "{consumed} consumed + {remaining} left (replacement)",
    adminGlobalLimitLabel = "Global limit",
    adminGlobalLimitResumes = "{source} — applies again at reset",
    adminResetNoCarryOver = "Restarts at {limit}: the overrun is not carried over",
    replaceLabel = "Replace the remaining credit",
    replaceHelp = "From 0 to 100 €, for the current period only. At reset, the account starts again from the global limit.",
    replaceHelpEnterpriseDriver = "Only changes {name}'s credit. The Enterprise's and the other drivers' credit does not change.",
    replaceInvalid = "Enter an amount from 0 to 100 €.",
    replacedTitle = "Remaining credit replaced: {from} → {to}.",
    replacedDetail = "For the current period. On {date}, back to the global limit ({limit}).",
    adminHistoryTitle = "AI credit history",
    adminPeriodSummary = "Current period since {start}: {calls} calls · {failed} failed or unreadable (counted) · {tokens} weighted tokens · {consumed}",
    columnInput = "Input",
    columnOutput = "Output",
    columnWeighted = "Weighted",
    columnCost = "Cost",
    decimalSeparator = ".",
    importExhaustedNeutralMessage = "Your AI credit is used up. The file was not analysed and nothing was counted. Resets on {date}.",
    rateUnitPrefix = "€1 =",
    rateUnitSuffix = "\$",
)
